/* eslint-disable react/prop-types */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames/bind";
import MediaQuery from "react-responsive";

import deleteBook from "../../images/delete-book.png";
import statusOk from "../../images/status-ok2.png";
import failed from "../../images/failed.png";
import styles from "./styles";
import placeholderImage from "../../images/placeholderimage.jpg";

import { itemTypes } from "../../config/types";

class BasketItem extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    last: PropTypes.bool,
    onDelete: PropTypes.func,
    book: PropTypes.shape({
      status: PropTypes.string,
      Title: PropTypes.string,
      Author: PropTypes.string,
      data: PropTypes.string,
      PublishedOn: PropTypes.string,
      SellbackPrice: PropTypes.number,
      ImageURL: PropTypes.string,
      EAN: PropTypes.string.isRequired,
    }),
  };

  static defaultProps = {
    classes: {},
    onDelete: () => {},
    book: {
      status: "no status",
      Title: "no name",
      Author: "no author",
      data: "no data",
      PublishedOn: "no date",
      SellbackPrice: 0,
      ImageURL: null,
    },
    last: false,
  };

  getType = (itemTypeId) =>
    itemTypes.find((item) => item.key === itemTypeId).value;

  handleImageError = () => {
    this.setState({ imageError: true });
  };

  renderBookImage = () => {
    const { classes, book } = this.props;
    const { imageError } = this.state;

    return (
      <img
        className={classes.bookPhoto}
        src={imageError ? placeholderImage : book.ImageURL}
        alt={`${book.ItemType ? this.getType(book.ItemType) : "book"}`}
        onError={this.handleImageError}
      />
    );
  };

  renderFailed = () => {
    const { classes } = this.props;
    return (
      <div className={classNames(classes.failed, classes.failedColor)}>
        <div className={classes.failedImageContainer}>
          <img className={classes.failedBig} src={failed} alt={"failed"} />
        </div>
        <div className={classes.failedText}>
          <span>SORRY</span>
          <span>NO OFFER</span>
        </div>
      </div>
    );
  };

  renderApplied = () => {
    const { classes, book } = this.props;
    return (
      <div className={classes.applied}>
        <div className={classes.searchTextAndStatusContainer}>
          <span className={classes.applyText}>ADDED TO BASKET</span>
          <img
            src={statusOk}
            alt={"status-ok"}
            className={classes.imageStatusOk}
          />
        </div>
        <span className={classes.applyPrice}>
          &#163;
          {book.SellbackPrice.toFixed(2)}
        </span>
      </div>
    );
  };

  renderName = () => {
    const { classes, book } = this.props;
    return (
      <span
        className={classNames(
          classes.name,
          !book.SellbackPrice ? classes.failedColor : {}
        )}
      >
        {book.Title}
      </span>
    );
  };

  renderDelete = () => {
    const { classes } = this.props;
    return (
      <div className={classes.marginRight}>
        <button className={classes.deleteButton} onClick={this.props.onDelete}>
          <img
            className={classes.failedSmall}
            src={deleteBook}
            alt={"delete"}
          />
        </button>
      </div>
    );
  };

  renderInfo = () => {
    const { classes, book } = this.props;
    return (
      <div className={classes.infoSubContainer}>
        <span className={classes.eanColor}>{book.EAN}</span>
        {book.ItemType === 1 ? (
          book.Author ? (
            <span>{`${this.getType(book.ItemType)} by ${book.Author}`}</span>
          ) : null
        ) : (
          <span>{`${this.getType(book.ItemType)}`}</span>
        )}
        <span>{book.data}</span>
        <span>{book.PublishedOn}</span>
      </div>
    );
  };

  renderDesktop = () => {
    const { classes, book, last } = this.props;
    console.log("book", book);
    return (
      <div
        className={classNames(
          classes.mainContainer,
          !last ? classes.borderBottom : null
        )}
      >
        {book.VoucherId && (
          <div className={classes.redeemDesktopContainer}>
            <div className={classes.redeemInnerContainer}>
              <p className={classes.redeemText}>Voucher issued</p>
            </div>
          </div>
        )}
        <div className={classes.leftPartContainer}>
          <div className={classes.imageContainer}>
            {this.renderDelete()}
            {this.renderBookImage()}
            {/* <img
              className={classes.bookPhoto}
              src={book.ImageURL}
              alt={`${this.getType(book.ItemType)}`}
            /> */}
          </div>
          <div className={classes.infoContainer}>
            {this.renderName()}
            {this.renderInfo()}
          </div>
        </div>
        {book.SellbackPrice ? this.renderApplied() : this.renderFailed()}
      </div>
    );
  };

  renderMobile = () => {
    const { classes, book } = this.props;

    return (
      <div
        className={classNames(
          classes.mainContainerMobile,
          classes.borderBottom
        )}
      >
        {book.VoucherId && (
          <div className={classes.redeemMobileContainer}>
            <div className={classes.redeemInnerContainer}>
              <p className={classes.redeemText}>Voucher issued</p>
            </div>
          </div>
        )}
        <div className={classes.mobileItemContainer}>
          <div className={classes.mobileFullInfo}>
            <div className={classes.imageContainer}>
              <img
                className={classes.bookPhoto}
                src={book.ImageURL}
                alt={`${this.getType(book.ItemType)}`}
              />
            </div>
            <div className={classes.mobileInfo}>
              {this.renderName()}
              {this.renderInfo()}
            </div>
          </div>
          <div className={classes.mobileNameDelete}>{this.renderDelete()}</div>
        </div>
        {book.SellbackPrice ? this.renderApplied() : this.renderFailed()}
      </div>
    );
  };

  render() {
    return (
      <MediaQuery minWidth={500}>
        {(matches) => (matches ? this.renderDesktop() : this.renderMobile())}
      </MediaQuery>
    );
  }
}

export default withStyles(styles)(BasketItem);
